import { Typography } from '@mui/material';
import PostUserSearch from '../PostUserSearch';

import './style.scss';

const PageTitle = ({ title = '', searchable=false }) => {
    return <div className='page-title'>
        <div className='page-title__title'>
            <h3>{title}</h3>
        </div>
        <div className='page-title__actions'>
            {
                searchable
                ? <PostUserSearch />
                : null
            }
        </div>
    </div>;
};

export default PageTitle;